import React, { Component } from 'react';
import $ from "jquery";

export default class CajaImagen extends Component {
  state={
    loading: true
  }
  bgImg=new Image();
  
  async componentDidMount(){
    var self=this;
    
    //Loading Image
    this.bgImg.src=this.props.path;
    $(this.bgImg).on('load', function() {
      self.setState({loading: false});
      document.getElementById('I'+self.props.imgNum).style.backgroundImage='url('+this.src+')';
      imageFuctions();
    });

    //Image Functions
    var imgNumI=this.props.imgNum;
    function imageFuctions(){
      $("#I"+imgNumI).click(function(){
        var SBWidht=(window.innerWidth-document.body.clientWidth)+40;
        $('#D'+imgNumI).css("display", "flex");
        $('#D'+imgNumI).animate({opacity: 1}, 300);
        $('body').css("overflow-y", "hidden");
        if(SBWidht>40){
          $('.ContenidoPaginaUser').css("paddingRight", SBWidht+'px');
        }
      });
      $("#Close"+imgNumI).click(function(){
          $('#D'+imgNumI).animate({opacity: 0}, 300, function(){
            $('#D'+imgNumI).css("display", "none");
          });
          $('body').css("overflow-y", "auto");
          $('.ContenidoPaginaUser').css("paddingRight", '40px');
      });

      $("#DelBTN"+imgNumI).click(function(){
        $('#DelScreen'+imgNumI).css("display", "flex");
        $('#DelScreen'+imgNumI).animate({opacity: 1}, 300);
      });
      $("#Cancel"+imgNumI).click(function(){
        $('#DelScreen'+imgNumI).animate({opacity: 0}, 300, function(){
          $('#DelScreen'+imgNumI).css("display", "none");
        });
      });

      $("#DeleteImage"+imgNumI).click(function(){
        $('#DelScreen'+imgNumI).animate({opacity: 0}, 300, function(){
          $('#DelScreen'+imgNumI).css("display", "none");
          $('.ContenidoPaginaUser').css("paddingRight", '40px');
        });
        $('#D'+imgNumI).animate({opacity: 0}, 300, function(){
          $('#D'+imgNumI).css("display", "none");
          $('body').css("overflow-y", "auto");
        });
      });
    }

  }

    render() {
        var dataLoader=<div className="LoadingContainer GradientLoader">
            <div className="loader"></div>    
        </div>
        return (
          <div className="CajaImagen">
            {this.state.loading ? dataLoader : <React.Fragment>
                <div className="ImagenItem" id={'I'+this.props.imgNum}></div>

                <div className="imgDisplay" id={'D'+this.props.imgNum}>
                  <div className="imgContainer">
                    <img src={this.props.path} alt={this.props.originalName} className="Lightbox" id={'Light'+this.props.imgNum}/>
                  </div>
                  <div className="imageOptions">
                    <button className="DeleteButton" id={'DelBTN'+this.props.imgNum}><i className="material-icons-round">delete</i></button>
                    <button id={'Close'+this.props.imgNum} className="CloseLightbox"><i className="material-icons-round">close</i></button>
                  </div>
                  <div className="deleteConfirm" id={'DelScreen'+this.props.imgNum}>
                    <div className="card">
                        <div className="body-card" style={{padding: "45px"}}>
                          <div className="info-card">
                            <h1>¿Borrar foto?</h1>
                            <p>Cuidado, sí das click en "aceptar", la foto se borrara de forma permanente.</p>
                          </div>
                          <div className="buttons-card">
                            <button className="btn" id={'Cancel'+this.props.imgNum}><i className="material-icons-round">clear</i>Cencelar</button>
                            <button className="btn" id={'DeleteImage'+this.props.imgNum} onClick={() => this.props.onDelete(this.props.imgNum)}>
                              <i className="material-icons-round">done</i>Aceptar
                            </button>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            }
          </div>
        )
    }
}
